var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCloudLogo20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#svg-public/img/cloud-logo-20.svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 148.125,
  height: 148.125,
  x: -63.437,
  y: -63.438,
  fill: "#07F",
  rx: 29.51
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M9.335 5.905a2.954 2.954 0 0 0-2.926 3.368l.124.89-.898.019a1.957 1.957 0 0 0 .042 3.913h7.981a2.622 2.622 0 1 0-.495-5.197l-.776.148-.156-.775a2.956 2.956 0 0 0-2.896-2.366Zm4.389 9.787H5.575v-.001a3.555 3.555 0 0 1-.79-6.995 4.552 4.552 0 0 1 8.81-1.442h.063a4.22 4.22 0 0 1 .066 8.438Z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "svg-public/img/cloud-logo-20.svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "#fff",
  rx: 5
})))));
export { SvgCloudLogo20 as ReactComponent };